const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { settingsHomeRoutes } from "@circle-react/lib/routes/settingsHome";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter/")({
  beforeLoad: ({
    context
  }) => {
    const isPhaseEEnabled = !!context.punditUserContext?.currentCommunitySettings?.email_hub_newsletter_phase_e_enabled;
    if (!isPhaseEEnabled) {
      redirect({
        to: settingsHomeRoutes.index.path,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});